import React, { useState, useEffect } from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from './HeroSection';
import CategorySection from './CategorySection';
import ProductGrid from './ProductGrid';
import PartnersSection from '../Home/PartnersSection';
import SEO from '../../components/common/SEO';

const VideoLibrary = () => {
  const [activeCategory, setActiveCategory] = useState('origin');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch products from backend
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/products`);
        const data = await res.json();
        setProducts(data);
      } catch (error) {
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Filter products based on active category
  const filteredProducts =
    activeCategory === 'all'
      ? products
      : products.filter(
          (product) =>
            product.category === activeCategory || product.categories?.includes(activeCategory)
        );

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Shop"
        description="Explore our rare and exceptional honey varieties, each a taste of the Mediterranean's liquid gold. From Thym to Eucalyptus, discover the full range of Elixir's premium honey collection."
        keywords="
          Elixir honey shop,
          Mediterranean honey varieties,
          Thym honey,
          Eucalyptus honey,
          Sidr honey,
          Orange Blossom honey,
          premium honey collection,
          buy honey online,
          luxury honey products
        "
      />
      <Header />

      <main className="flex-grow">
        <HeroSection
          title="Discover the Exquisite World of Elixir"
          description="Explore our rare and exceptional honey varieties, each a taste of the Mediterranean's liquid gold"
        />
        <section className="max-w-3xl mx-auto px-4 py-6 text-center">
          <h2 className="text-2xl font-bold text-[#d4af37] mb-2">Why Elixir Honey?</h2>
          <p className="text-lg text-[#475467] mb-4">
            Elixir honey is harvested from the sun-drenched Mediterranean landscapes of Tunisia, crafted with traditional beekeeping methods and a passion for purity. Our honey varieties are renowned for their unique flavors, health benefits, and luxurious presentation. Experience the difference that nature and tradition make in every jar.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            <a href="/about" className="text-[#d4af37] underline hover:text-yellow-600">About Elixir</a>
            <a href="/wellness" className="text-[#d4af37] underline hover:text-yellow-600">Honey & Wellness</a>
            <a href="/blog" className="text-[#d4af37] underline hover:text-yellow-600">Honey Blog</a>
          </div>
        </section>
        <CategorySection activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
        {loading ? (
          <div className="text-center py-10 text-gray-500">Loading products...</div>
        ) : (
          <ProductGrid products={filteredProducts} />
        )}
        <section className="max-w-3xl mx-auto px-4 py-8 mt-8 mb-12 bg-[#f7fbff] rounded-xl shadow">
          <h3 className="text-xl font-semibold text-[#d4af37] mb-2">What Our Customers Say</h3>
          <ul className="text-[#475467] text-base space-y-2">
            <li>"The best honey I've ever tasted! The flavor is so rich and pure." – Amira B.</li>
            <li>"I love knowing my honey is organic and supports traditional beekeepers." – Karim T.</li>
            <li>"Fast shipping and beautiful packaging. Makes a perfect gift!" – Leila S.</li>
          </ul>
          <div className="mt-4 text-sm text-[#475467]">Want to know more? <a href="/about" className="text-[#d4af37] underline hover:text-yellow-600">Read our story</a> or <a href="/contact" className="text-[#d4af37] underline hover:text-yellow-600">contact us</a>.</div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VideoLibrary;
